import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { bonustextStyle, paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { Image, language, t } from '@slot-nx/core'

export const Paragraph6 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title4')}
          anchor={[0.5, 0]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Text
          text={t('gameRules_title4_content_1')}
          x={60}
          y={100}
          style={paragraphStyle}
        />
        <Image
          name={language === 'ZH_TW' ? 'FGA' : 'fga'}
          image={language === 'ZH_TW' ? 'FGA' : 'fga'}
          x={50}
          y={500}
          anchor={[0, 0.5]}
          width={143}
          height={167}
        />
        <Image
          name={language === 'ZH_TW' ? 'FGB' : 'fgb'}
          image={language === 'ZH_TW' ? 'FGB' : 'fgb'}
          x={50}
          y={700}
          anchor={[0, 0.5]}
          width={143}
          height={167}
        />
        <Text
          text={t('gameRules_title4_content_2')}
          anchor={[0, 0.5]}
          x={230}
          y={500}
          style={bonustextStyle}
        />
        <Text
          text={t('gameRules_title4_content_3')}
          anchor={[0, 0.5]}
          x={230}
          y={700}
          style={bonustextStyle}
        />
        <Text
          text={t('gameRules_title4_content_4')}
          x={60}
          y={850}
          style={paragraphStyle}
        />
        <Text
          text={t('gameRules_title4_content_5')}
          x={60}
          y={1000}
          style={paragraphStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
